import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles, Paper } from './../../../../themes/default';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit,
    border: `1px solid ${ theme.palette.grey[200] }`,
    borderRadius: theme.spacing.unit / 2,
    boxShadow: theme.shadows[1],
    flex: 1
  }
});

const Main = ({ children, ...rest }) => {

  const { classes } = rest;

  return (
    <Paper square className={ classNames('Container-Main', classes.root) } { ...rest }>
      { children }
    </Paper>
  )
}

Main.propTypes = {
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(Main);
